import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

class MacOperatorViewVerifyAndAccept extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    //meta title
    document.title = "machine operator flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="View Verify & Accept" />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <form className="needs-validation">
                      <div className="d-lg-flex d-block justify-content-between">
                        <div>
                          <h4 className="pb-3 text-black fw-bold">
                            View Verify & Accept
                          </h4>
                        </div>
                        {/* <div className="mb-3 row">
                          <label
                            htmlFor="date"
                            className="col-12 col-sm-2 col-lg-4"
                          >
                            <h5 className="fs-5 fw-bold text-black">Date:</h5>
                          </label>
                          <div className="col-12 col-sm-5 col-lg-4">
                            <input
                              disabled
                              className="border-0 fs-5 bg-white"
                              type="date"
                              name="date"
                            />
                          </div>
                        </div> */}
                      </div>
                      <div className="mb-3 row">
                        <label
                          htmlFor="cubeID"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">Belt ID</h5>
                        </label>
                        <div className="col-md-10 col-12">
                          <select
                            className="form-control fs-5"
                            name="cubeID"
                            disabled
                          >
                            <option value="" disabled>
                              select
                            </option>
                            <option value="1">1-Today’s Date</option>
                            <option value="2">2-Today’s Date</option>
                            <option value="3">3-Today’s Date</option>
                            <option value="4">4-Today’s Date</option>
                          </select>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label
                          htmlFor="machineOperator"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                          {this.props.t("Machine Operator")}
                          </h5>
                        </label>
                        <div className="col-md-10 col-12">
                          <select
                            className="form-control fs-5"
                            name="machineOperator"
                            disabled
                          >
                            <option value="" disabled>
                              select
                            </option>
                            <option value="1">1 Machine Operator</option>
                            <option value="2">2 Machine Operator</option>
                            <option value="3">3 Machine Operator</option>
                            <option value="4">4 Machine Operator</option>
                          </select>
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label
                          htmlFor="selectMachine"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            Select Machine
                          </h5>
                        </label>
                        <div className="col-md-10 col-12">
                          <input
                            disabled
                            className="form-control fs-5"
                            name="selectMachine"
                            placeholder="Machine 2"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label
                          htmlFor="assignDate"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            Assigned Date
                          </h5>
                        </label>
                        <div className="col-md-10 col-12">
                          <input
                            disabled
                            className="form-control fs-5"
                            type="date"
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label
                          htmlFor="fillerNotes"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            {this.props.t('Filler Notes')}
                          </h5>
                        </label>
                        <div className="col-md-10">
                          <textarea
                            disabled
                            className="form-control fs-5"
                            type="text"
                            name="fillerNotes"
                            rows="5"
                            placeholder="Please Take of HPHT First Priority"
                          ></textarea>
                        </div>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default MacOperatorViewVerifyAndAccept;
